var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-graph",attrs:{"id":_vm.id}},[_c('h2',[_vm._v("222")])])}
var staticRenderFns = []

export { render, staticRenderFns }